import { redirect } from '@tanstack/react-router';

import { loginWithToken } from '../authentication';

import { applyLocale } from '@/i18n';

const JWT_SHAPE_REGEX = /^[\w-]+\.[\w-]+\.[\w-]+$/;

export const DEFAULT_REDIRECT_TO = '/home';

export interface LinkLoginSearch {
  redirectTo?: string;
}

interface HandleLinkLoginParams extends LinkLoginSearch {
  token: string;
  locale?: string;
}

export function isTokenShaped(value: string): boolean {
  return JWT_SHAPE_REGEX.test(value);
}

export function sanitizeRedirectTo(redirectTo: unknown): string {
  if (typeof redirectTo !== 'string') {
    return DEFAULT_REDIRECT_TO;
  }

  const isInternalPath =
    redirectTo.startsWith('/') && !redirectTo.startsWith('//') && !redirectTo.startsWith('/\\');

  return isInternalPath ? redirectTo : DEFAULT_REDIRECT_TO;
}

export function validateLinkLoginSearch(search: Record<string, unknown>): LinkLoginSearch {
  return { redirectTo: typeof search.redirectTo === 'string' ? search.redirectTo : undefined };
}

export function handleLinkLogin({ token, locale, redirectTo }: HandleLinkLoginParams): void {
  if (!isTokenShaped(token)) {
    return;
  }

  if (locale !== undefined) {
    applyLocale(locale);
  }

  try {
    loginWithToken(token);
  } catch {
    throw redirect({ to: '/invalid-token' });
  }

  throw redirect({ href: sanitizeRedirectTo(redirectTo) });
}
